'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = _applyEmptyState;

var _updeep = require('updeep');

var _updeep2 = _interopRequireDefault(_updeep);

var _list3 = require('./_list');

var _list4 = _interopRequireDefault(_list3);

var _total2 = require('./_total');

var _total3 = _interopRequireDefault(_total2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyEmptyState(root, listName, options) {
    var list = (0, _list4.default)(root, listName);
    var total = (0, _total3.default)(list);

    if (total > 0) return root;

    return (0, _updeep2.default)({
        list: (0, _defineProperty3.default)({}, listName, options)
    }, root);
}